import { c as _c } from "react/compiler-runtime";
import { ThumbnailImage } from "@components/common/thumbnail-image";
import { useAppSelector } from "@store/store-helper";
import { getSnapshotByIdSelector } from "@store/projects/projects-selector";
import { ListItemText } from "@flat-ui";
import { defaultProjectThumbnail } from "@utils/project-utils";
/** List item in bulk action dialog for snapshots */
export function SnapshotListContent(t0) {
  const $ = _c(10);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.id) {
    t1 = getSnapshotByIdSelector(item.id);
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedSnapshot = useAppSelector(t1);
  if (selectedSnapshot === null) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "40px",
      width: "56px",
      maxHeight: "100%",
      maxWidth: "100%",
      objectFit: "contain",
      borderRadius: "8px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== selectedSnapshot.thumbnailUrl) {
    t3 = <ThumbnailImage src={selectedSnapshot.thumbnailUrl} fallbackSrc={defaultProjectThumbnail} alt="Snapshot thumbnail" sx={t2} />;
    $[3] = selectedSnapshot.thumbnailUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== selectedSnapshot.name) {
    t4 = <ListItemText primary={<var>{selectedSnapshot.name}</var>} />;
    $[5] = selectedSnapshot.name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}